import React, { useState, useRef,useEffect } from "react";
import Chart from "react-apexcharts";
import { getAuthorization } from "../../../axios/AxiosAut";

export default function General() {
  const [Data, setData] = useState([]);
  const getData = () => {
    getAuthorization()
      .get(`dashboard/statistics/get_items_sold/`)
      .then((res) => {
        console.log("tabel data", res.data 
        );
        setData(res.data
          );
      })
      .catch((err) => {
        console.log("err", err);
      });
  };
  useEffect(() => {
    getData();
    console.log("Data.....", Data);
  }, []);

  const [Perferctorder, SetPerferctorder] = useState({
    options: {
      chart: {
        toolbar: {
          show: false,
        },
      },
      colors: ["#1F78B4"],

      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
      yaxis: {
        forceNiceScale: false,
        max: 100,
        labels: {
          formatter: (value) => value.toFixed(0) + "%",
        },
      },
      stroke: {
        curve: "smooth",
      },
      markers: {
        size: 4,
      },
      states: {
        normal: {
          filter: {
            type: "none",
            value: 0,
          },
        },
        hover: {
          filter: {
            type: "lighten",
            value: 0.15,
          },
        },
        active: {
          allowMultipleDataPointsSelection: false,
          filter: {
            type: "darken",
            value: 0.35,
          },
        },
      },
    },

    series: [
      {
        name: "Perfect Order Rate",
        data: [83, 80, 92, 87, 95, 90, 97, 87, 84, 78, 87, 96],
      },
    ],
  });
  const [Orderrate, Setrederrate] = useState({
    options: {
      chart: {
        toolbar: {
          show: false,
        },
      },
      colors: ["#ACC3E2", "#1F78B4"],

      xaxis: {
        categories: [
          1, 5, 10, 15, 20, 25, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80,
          85, 90, 95, 100,
        ],
      },
      yaxis: {
        forceNiceScale: false,
        max: 100,
        labels: {
          formatter: (value) => value.toFixed(0) + "%",
        },
      },
      stroke: {
        curve: "smooth",
      },
      markers: {
        size: 4,
      },
      states: {
        normal: {
          filter: {
            type: "none",
            value: 0,
          },
        },
        hover: {
          filter: {
            type: "lighten",
            value: 0.15,
          },
        },
        active: {
          allowMultipleDataPointsSelection: false,
          filter: {
            type: "darken",
            value: 0.35,
          },
        },
      },
      fill: {
        colors: ["#ACC3E2", "#1F78B4"],
      },
    },

    series: [
      {
        name: "Order Rate",
        data: [13, 80, 92, 7, 25, 29, 97, 77, 84, 70, 80, 76],
      },
      {
        name: "Perfect order Rate",
        data: [23, 50, 52, 87, 5, 90, 7, 67, 4, 78, 87, 6],
      },
    ],
  });
  const [Fulfillment, SetFulfillment] = useState({
    options: {
      chart: {
        toolbar: {
          show: false,
        },
      },
      colors: ["#1F78B4"],

      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
      yaxis: {
        forceNiceScale: false,
        max: 100,
        labels: {
          formatter: (value) => value.toFixed(0) + "%",
        },
      },
      stroke: {
        curve: "smooth",
      },
      markers: {
        size: 4,
      },
      states: {
        normal: {
          filter: {
            type: "none",
            value: 0,
          },
        },
        hover: {
          filter: {
            type: "lighten",
            value: 0.15,
          },
        },
        active: {
          allowMultipleDataPointsSelection: false,
          filter: {
            type: "darken",
            value: 0.35,
          },
        },
      },
    },

    series: [
      {
        name: "Fulfilment Rate",
        data: [83, 80, 92, 87, 95, 90, 97, 87, 84, 78, 87, 96],
      },
    ],
  });
  const [Solditems, SetSolditems] = useState({
    options: {
      chart: {
        toolbar: {
          show: false,
        },
      },
      colors: ["#ACC3E2", "#1F78B4"],
      xaxis: {
        categories: [
          1, 5, 10, 15, 20, 25, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80,
          85, 90, 95, 100,
        ],
      },
      yaxis: {
        forceNiceScale: false,
        categories: [],
        // max: 100,
        labels: {
          formatter: (value) => value.toFixed(0) + "M",
        },
      },
      stroke: {
        curve: "smooth",
      },
      markers: {
        size: 4,
      },
      states: {
        normal: {
          filter: {
            type: "none",
            value: 0,
          },
        },
        hover: {
          filter: {
            type: "lighten",
            value: 0.15,
          },
        },
        active: {
          allowMultipleDataPointsSelection: false,
          filter: {
            type: "darken",
            value: 0.35,
          },
        },
      },
      fill: {
        colors: ["#ACC3E2", "#1F78B4"],
      },
    },

    series: [
      {
        name: "Sale Rate",
        data: [13, 180, 92, 7, 25, 29, 97, 77, 84, 70, 80, 76],
      },
      {
        name: "Perfect Sale Rate",
        data: [23, 50, 52, 87, 5, 90, 7, 67, 4, 78, 87, 6],
      },
    ],
  });
  const [Shipping, SetShipping] = useState({
    options: {
      chart: {
        toolbar: {
          show: false,
        },
      },
      colors: ["#1F78B4"],

      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
      yaxis: {
        forceNiceScale: false,
        max: 100,
        labels: {
          formatter: (value) => value.toFixed(0) + "%",
        },
      },
      stroke: {
        curve: "smooth",
      },
      markers: {
        size: 4,
      },
      states: {
        normal: {
          filter: {
            type: "none",
            value: 0,
          },
        },
        hover: {
          filter: {
            type: "lighten",
            value: 0.15,
          },
        },
        active: {
          allowMultipleDataPointsSelection: false,
          filter: {
            type: "darken",
            value: 0.35,
          },
        },
      },
    },

    series: [
      {
        name: "Shipping Rate",
        data: [83, 80, 92, 87, 95, 90, 97, 87, 84, 78, 87, 96],
      },
    ],
  });
  const [Return, SetReturn] = useState({
    options: {
      chart: {
        toolbar: {
          show: false,
        },
      },
      colors: ["#1F78B4"],

      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
      yaxis: {
        forceNiceScale: false,
        max: 100,
        labels: {
          formatter: (value) => value.toFixed(0) + "%",
        },
      },
      stroke: {
        curve: "smooth",
      },
      markers: {
        size: 4,
      },
      states: {
        normal: {
          filter: {
            type: "none",
            value: 0,
          },
        },
        hover: {
          filter: {
            type: "lighten",
            value: 0.15,
          },
        },
        active: {
          allowMultipleDataPointsSelection: false,
          filter: {
            type: "darken",
            value: 0.35,
          },
        },
      },
    },

    series: [
      {
        name: "Rate of Returns",
        data: [83, 80, 92, 87, 95, 90, 97, 87, 84, 78, 87, 96],
      },
    ],
  });
  const [Inventory, SetInventory] = useState({
    options: {
      chart: {
        toolbar: {
          show: false,
        },
        type: "bar",
        height: 350,
      },
      colors: ["#ACC3E2", "#1F78B4"],
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded",
          // colors:['red','black']
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: ["06-24", "06-25", "06-26", "06-27", "06-28", "06-29"],
      },
      yaxis: {
        // title: {
        //   text: '$ (thousands)'
        // }
        forceNiceScale: false,
        max: 100,
        labels: {
          formatter: (value) => value.toFixed(0) + "%",
        },
      },
      // fill: {
      //   opacity: 1
      // },
      fill: {
        colors: ["#ACC3E2", "#1F78B4"],
      },

      tooltip: {
        // y: {
        //   formatter: function (val) {
        //     return "$ " + val + " thousands"
        //   }
        // }
      },
    },
    series: [
      {
        name: "Previous",
        data: [44, 55, 57, 56, 61, 58],
      },
      {
        name: "Present",
        data: [76, 85, 101, 98, 87, 105],
      },
    ],
  });

  const inventoryRef = useRef(null);
  const saleRatioRef = useRef(null);
  const backOrderRef = useRef(null);
  const perfectOrderRef = useRef(null);
  const fulfillmentRef = useRef(null);
  const shippingRef = useRef(null);
  const returnRef = useRef(null);
  const totalOrderRef = useRef(null);
  const orderLeadRef = useRef(null);
  const itemSoldRef = useRef(null);
  const itemReturnRef = useRef(null);

  const handleScroll = (ref) => {
    console.log("scrool down");
    window.scrollTo({
      top: ref.offsetTop - 100,
      left: 0,
      behavior: "smooth",
    });
  };

  return (
  <main className="max-w-full px-4 sm:px-6 lg:px-8 pt-4">
      <div class="flex flex-wrap justify-center mt-8">
        <div
          className="w-full flex-1 shadow-md shadow-slate-400 bg-white sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl mr-6 "
          onClick={() => {
            handleScroll(inventoryRef.current);
          }}
        >
          <div className="text-center  mt-4">
            <div className="text-center">
              <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                <svg
                  className="relative top-1.5 left-1.5"
                  width="48"
                  height="48"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.8684 17.263L17.222 16.9095L17.5755 17.263L17.222 17.6166L16.8684 17.263ZM13.0246 12.7121L17.222 16.9095L16.5149 17.6166L12.3175 13.4192L13.0246 12.7121ZM17.222 17.6166L13.0246 21.814L12.3175 21.1069L16.5149 16.9095L17.222 17.6166Z"
                    fill="#1F78B4"
                  />
                  <path
                    d="M13.7204 8.86841L17.9177 8.86841"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                  <path
                    d="M16.8684 17.2631H8.47368C6.15553 17.2631 4.27631 15.3839 4.27631 13.0658V13.0658C4.27631 10.7476 6.15553 8.86841 8.47368 8.86841H9.52302"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                </svg>
              </button>
            </div>
          </div>
          <h1 className="text-4xl text-center font-bold mt-4">34%</h1>
          <h1 className="text-lg text-center text-gray-500 mt-2 font-bold ">
            Turnover Frequency
          </h1>
          <p className="text-lime-400 text-center mb-1">
            <span>
              <span className="inline-block">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                    fill="#26F32E"
                  />
                  <path
                    d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                    fill="#26F32E"
                  />
                </svg>
              </span>
            </span>
            <span className="ml-1 font-medium">45.38%</span>
          </p>
          <div className="text-center flex justify-center ml-auto mt-1 mb-4">
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                Y
              </button>
            </div>
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                M
              </button>
            </div>

            <div className="">
              <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                {" "}
                W
              </button>
            </div>
          </div>
        </div>
        <div
          className="w-full flex-1 shadow-md shadow-slate-400 bg-white sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl mr-6"
          onClick={() => {
            handleScroll(saleRatioRef.current);
          }}
        >
          <div className="text-center  mt-4">
            <div className="text-center">
              <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                <svg
                  className="relative top-1.5 left-1.5"
                  width="44"
                  height="44"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="12" cy="12" r="8.5" stroke="#1F78B4" />
                  <path
                    d="M16.2426 7.75736C15.1174 6.63214 13.5913 6 12 6C10.4087 6 8.88258 6.63214 7.75736 7.75736C6.63214 8.88258 6 10.4087 6 12C6 13.5913 6.63214 15.1174 7.75736 16.2426L12 12L16.2426 7.75736Z"
                    fill="#1F78B4"
                  />
                </svg>
              </button>
            </div>
          </div>
          <h1 className="text-4xl text-center font-bold mt-4">62%</h1>
          <h1 className="text-lg text-center text-gray-500 mt-2 font-bold ">
            Inventory to Sales Ratio
          </h1>
          <p className="text-lime-400 text-center mb-1">
            <span>
              <span className="inline-block">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 7L6.29289 7.70711L7 8.41421L7.70711 7.70711L7 7ZM2.79289 4.20711L6.29289 7.70711L7.70711 6.29289L4.20711 2.79289L2.79289 4.20711ZM7.70711 7.70711L11.2071 4.20711L9.79289 2.79289L6.29289 6.29289L7.70711 7.70711Z"
                    fill="#26F32E"
                  />
                  <path
                    d="M7 10.5L6.29289 11.2071L7 11.9142L7.70711 11.2071L7 10.5ZM2.79289 7.70711L6.29289 11.2071L7.70711 9.79289L4.20711 6.29289L2.79289 7.70711ZM7.70711 11.2071L11.2071 7.70711L9.79289 6.29289L6.29289 9.79289L7.70711 11.2071Z"
                    fill="#26F32E"
                  />
                </svg>
              </span>
            </span>
            <span className="ml-1 font-medium">12.38%</span>
          </p>
          <div className="text-center flex justify-center ml-auto mt-1 mb-4">
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                Y
              </button>
            </div>
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                M
              </button>
            </div>

            <div className="">
              <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                {" "}
                W
              </button>
            </div>
          </div>
        </div>
        <div
          class="w-full flex-1 shadow-md shadow-slate-400 bg-white sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl mr-6 "
          onClick={() => {
            handleScroll(backOrderRef.current);
          }}
        >
          <div className="text-center  mt-4">
            <div className="text-center">
              <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                <svg
                  className="relative top-1.5 left-1.5"
                  width="44"
                  height="44"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="12" cy="12" r="9" stroke="#1F78B4" />
                  <path d="M9.0001 14.9998L15.0001 8.99976" stroke="#1F78B4" />
                  <path d="M15 15L9 9" stroke="#1F78B4" />
                </svg>
              </button>
            </div>
          </div>
          <h1 className="text-4xl text-center font-bold mt-4">07%</h1>
          <h1 className="text-lg text-center text-gray-500 mt-2 font-bold">
            Back Order Rate
          </h1>
          <p className="text-red-600 text-center mb-1">
            <span>
              <span className="inline-block">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                    fill="#F32626"
                  />
                  <path
                    d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                    fill="#F32626"
                  />
                </svg>
              </span>
            </span>
            <span className="ml-1 font-medium">03.88%</span>
          </p>
          <div className="text-center flex justify-center ml-auto mt-1 mb-4">
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                Y
              </button>
            </div>
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                M
              </button>
            </div>

            <div className="">
              <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                {" "}
                W
              </button>
            </div>
          </div>
        </div>
        <div
          class="w-full flex-1 shadow-md shadow-slate-400 bg-white sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl "
          onClick={() => {
            handleScroll(perfectOrderRef.current);
          }}
        >
          <div className="text-center  mt-4">
            <div className="text-center">
              <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                <svg
                  className="relative top-1.5 left-1.5"
                  width="48"
                  height="48"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="9"
                    stroke="#1F78B4"
                    stroke-width="1.2"
                  />
                  <path
                    d="M8 12L11 15L16 9"
                    stroke="#1F78B4"
                    stroke-width="1.2"
                  />
                </svg>
              </button>
            </div>
          </div>
          <h1 className="text-4xl text-center font-bold mt-4">86%</h1>
          <h1 className="text-lg text-center text-gray-500 mt-2 font-bold">
            Perfect Order Rate
          </h1>
          <p className="text-lime-400 text-center mb-1">
            <span>
              <span className="inline-block">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                    fill="#26F32E"
                  />
                  <path
                    d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                    fill="#26F32E"
                  />
                </svg>
              </span>
            </span>
            <span className="ml-1 font-medium">05.25%</span>
          </p>
          <div className="text-center flex justify-center ml-auto mt-1 mb-4">
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                Y
              </button>
            </div>
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                M
              </button>
            </div>

            <div className="">
              <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                {" "}
                W
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-wrap justify-center mt-8">
        <div
          className="w-full flex-1 shadow-md shadow-slate-400 bg-white sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl mr-6"
          onClick={() => {
            handleScroll(fulfillmentRef.current);
          }}
        >
          <div className="text-center  mt-4">
            <div className="text-center">
              <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                <svg
                  className="relative top-1.5 left-1.5"
                  width="42"
                  height="42"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2 14L5.23309 16.4248C5.66178 16.7463 6.26772 16.6728 6.60705 16.2581L15 6"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.191 15.3932L11.9153 16.7726C12.5572 17.2861 13.4928 17.1873 14.0133 16.5511L22.387 6.31663C22.5618 6.10291 22.5303 5.7879 22.3166 5.61304C22.1029 5.43817 21.7879 5.46967 21.613 5.6834L13.2393 15.9179C13.0658 16.13 12.754 16.1629 12.54 15.9917L10.8243 14.6192L10.191 15.3932Z"
                    fill="#1F78B4"
                  />
                </svg>
              </button>
            </div>
          </div>
          <h1 className="text-4xl text-center font-bold mt-4">85%</h1>
          <h1 className="text-lg text-center text-gray-500 mt-2 font-bold ">
            Fulfillment Accuracy Rate
          </h1>
          <p className="text-lime-400 text-center mb-1">
            <span>
              <span className="inline-block">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                    fill="#26F32E"
                  />
                  <path
                    d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                    fill="#26F32E"
                  />
                </svg>
              </span>
            </span>
            <span className="ml-1 font-medium">6.2%</span>
          </p>
          <div className="text-center flex justify-center ml-auto mt-1 mb-4">
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                Y
              </button>
            </div>
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                M
              </button>
            </div>

            <div className="">
              <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                {" "}
                W
              </button>
            </div>
          </div>
        </div>
        <div
          className="w-full flex-1 shadow-md shadow-slate-400 bg-white sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl mr-6"
          onClick={() => {
            handleScroll(shippingRef.current);
          }}
        >
          <div className="text-center  mt-4">
            <div className="text-center">
              <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                <svg
                  className="relative top-1.5 left-1.5"
                  width="44"
                  height="44"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="12" cy="14" r="8" stroke="#1F78B4" />
                  <path
                    d="M12 14L12 11"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                  <path
                    d="M17.5 7.5L19 6"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                  <path
                    d="M10.0681 2.37059C10.1821 2.26427 10.4332 2.17033 10.7825 2.10332C11.1318 2.03632 11.5597 2 12 2C12.4403 2 12.8682 2.03632 13.2175 2.10332C13.5668 2.17033 13.8179 2.26427 13.9319 2.37059"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                </svg>
              </button>
            </div>
          </div>
          <h1 className="text-4xl text-center font-bold mt-4">94%</h1>
          <h1 className="text-lg text-center text-gray-500 mt-2 font-bold ">
            On-time Shipping Rate
          </h1>
          <p className="text-red-600 text-center mb-1">
            <span>
              <span className="inline-block">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 7L6.29289 7.70711L7 8.41421L7.70711 7.70711L7 7ZM2.79289 4.20711L6.29289 7.70711L7.70711 6.29289L4.20711 2.79289L2.79289 4.20711ZM7.70711 7.70711L11.2071 4.20711L9.79289 2.79289L6.29289 6.29289L7.70711 7.70711Z"
                    fill="#F32626"
                  />
                  <path
                    d="M7 10.5L6.29289 11.2071L7 11.9142L7.70711 11.2071L7 10.5ZM2.79289 7.70711L6.29289 11.2071L7.70711 9.79289L4.20711 6.29289L2.79289 7.70711ZM7.70711 11.2071L11.2071 7.70711L9.79289 6.29289L6.29289 9.79289L7.70711 11.2071Z"
                    fill="#F32626"
                  />
                </svg>
              </span>
            </span>
            <span className="ml-1 font-medium">12.38%</span>
          </p>
          <div className="text-center flex justify-center ml-auto mt-1 mb-4">
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                Y
              </button>
            </div>
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                M
              </button>
            </div>

            <div className="">
              <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                {" "}
                W
              </button>
            </div>
          </div>
        </div>
        <div
          class="w-full flex-1 shadow-md shadow-slate-400 bg-white sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl mr-6"
          onClick={() => {
            handleScroll(returnRef.current);
          }}
        >
          <div className="text-center  mt-4">
            <div className="text-center">
              <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                <svg
                  className="relative top-1.5 left-1.5"
                  width="44"
                  height="44"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14 15L14.3536 14.6464L14.7071 15L14.3536 15.3536L14 15ZM10.3536 10.6464L14.3536 14.6464L13.6464 15.3536L9.64645 11.3536L10.3536 10.6464ZM14.3536 15.3536L10.3536 19.3536L9.64645 18.6464L13.6464 14.6464L14.3536 15.3536Z"
                    fill="#1F78B4"
                  />
                  <path
                    d="M19.7942 12.75C20.8108 11.8697 21.2012 10.8431 20.902 9.83767C20.6027 8.83221 19.6315 7.90702 18.1463 7.2128C16.6612 6.51858 14.7497 6.09623 12.7232 6.01455C10.6967 5.93287 8.67454 6.19667 6.98617 6.76297C5.2978 7.32928 4.04265 8.16473 3.42516 9.13325C2.80766 10.1018 2.86421 11.1463 3.58559 12.0967C4.30696 13.0471 5.65067 13.8474 7.39784 14.3672C9.14501 14.887 11.1927 15.0957 13.2074 14.9593"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                </svg>
              </button>
            </div>
          </div>
          <h1 className="text-4xl text-center font-bold mt-4">02%</h1>
          <h1 className="text-lg text-center text-gray-500 mt-2 font-bold">
            Rate of returns
          </h1>
          <p className="text-red-600 text-center mb-1">
            <span>
              <span className="inline-block">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                    fill="#F32626"
                  />
                  <path
                    d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                    fill="#F32626"
                  />
                </svg>
              </span>
            </span>
            <span className="ml-1 font-medium">03.88%</span>
          </p>
          <div className="text-center flex justify-center ml-auto mt-1 mb-4">
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                Y
              </button>
            </div>
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                M
              </button>
            </div>

            <div className="">
              <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                {" "}
                W
              </button>
            </div>
          </div>
        </div>
        <div
          class="w-full flex-1 shadow-md shadow-slate-400 bg-white sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl "
          onClick={() => {
            handleScroll(totalOrderRef.current);
          }}
        >
          <div className="text-center  mt-4">
            <div className="text-center">
              <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                <svg
                  className="relative top-1.5 left-1.5"
                  width="48"
                  height="48"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="12" cy="12" r="8.5" stroke="#1F78B4" />
                  <path
                    d="M16.5 12H12.25C12.1119 12 12 11.8881 12 11.75V8.5"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                </svg>
              </button>
            </div>
          </div>
          <h1 className="text-4xl text-center font-bold mt-4">14.84D</h1>
          <h1 className="text-lg text-center text-gray-500 mt-2 font-bold">
            Total Order Cycle Time
          </h1>
          <p className="text-lime-400 text-center mb-1">
            <span>
              <span className="inline-block">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                    fill="#26F32E"
                  />
                  <path
                    d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                    fill="#26F32E"
                  />
                </svg>
              </span>
            </span>
            <span className="ml-1 font-medium">0.8%</span>
          </p>
          <div className="text-center flex justify-center ml-auto mt-1 mb-4">
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                Y
              </button>
            </div>
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                M
              </button>
            </div>

            <div className="">
              <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                {" "}
                W
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="flex w-3/4  flex-wrap justify-center mt-8 mb-8">
        <div className="w-full flex-1 shadow-md shadow-slate-400 bg-white sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl mr-6">
          <div className="text-center  mt-4">
            <div className="text-center">
              <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                <svg
                  className="relative top-1.5 left-1.5"
                  width="46"
                  height="46"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.28249 5.28248C3.72835 6.83662 2.76118 8.88154 2.54575 11.0688C2.33032 13.2561 2.87996 15.4504 4.10104 17.2779C5.32211 19.1054 7.13906 20.4529 9.24229 21.0909C11.3455 21.7289 13.6049 21.6179 15.6355 20.7769C17.6661 19.9358 19.3422 18.4166 20.3783 16.4783C21.4143 14.5399 21.7462 12.3023 21.3175 10.1466C20.8887 7.991 19.7257 6.05072 18.0267 4.6564C16.3278 3.26208 14.1979 2.5 12 2.5"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                  <path
                    d="M12 12L7 7"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                  <path d="M12 2.5V5" stroke="#1F78B4" stroke-linecap="round" />
                  <path
                    d="M21 12L19 12"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                  <path d="M12 19V21" stroke="#1F78B4" stroke-linecap="round" />
                  <path
                    d="M5 12L3 12"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                </svg>
              </button>
            </div>
          </div>
          <h1 className="text-4xl text-center font-bold mt-4">15.84D</h1>
          <h1 className="text-lg text-center text-gray-500 mt-2 font-bold ">
            Order Lead Time
          </h1>
          <p className="text-lime-400 text-center mb-1">
            <span>
              <span className="inline-block">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                    fill="#26F32E"
                  />
                  <path
                    d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                    fill="#26F32E"
                  />
                </svg>
              </span>
            </span>
            <span className="ml-1 font-medium">45.38%</span>
          </p>
          <div className="text-center flex justify-center ml-auto mt-1 mb-4">
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                Y
              </button>
            </div>
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                M
              </button>
            </div>

            <div className="">
              <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                {" "}
                W
              </button>
            </div>
          </div>
        </div>
        <div
          className="w-full flex-1 shadow-md shadow-slate-400 bg-white sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl mr-6"
          onClick={() => {
            handleScroll(itemSoldRef.current);
          }}
        >
          <div className="text-center  mt-4">
            <div className="text-center">
              <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                <svg
                  className="relative top-1.5 left-1.5"
                  width="46"
                  height="46"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 12L8 8C8 5.79086 9.79086 4 12 4V4C14.2091 4 16 5.79086 16 8L16 12"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                  <path
                    d="M3.69435 12.6678C3.83942 10.9269 3.91196 10.0565 4.48605 9.52824C5.06013 9 5.9336 9 7.68053 9H16.3195C18.0664 9 18.9399 9 19.514 9.52824C20.088 10.0565 20.1606 10.9269 20.3057 12.6678L20.8195 18.8339C20.904 19.8474 20.9462 20.3542 20.6491 20.6771C20.352 21 19.8435 21 18.8264 21H5.1736C4.15655 21 3.64802 21 3.35092 20.6771C3.05382 20.3542 3.09605 19.8474 3.18051 18.8339L3.69435 12.6678Z"
                    stroke="#1F78B4"
                  />
                </svg>
              </button>
            </div>
          </div>
          <h1 className="text-4xl text-center font-bold mt-4">2.86K</h1>
          <h1 className="text-lg text-center text-gray-500 mt-2 font-bold ">
            Items Sold
          </h1>
          <p className="text-red-600 text-center mb-1">
            <span>
              <span className="inline-block">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 7L6.29289 7.70711L7 8.41421L7.70711 7.70711L7 7ZM2.79289 4.20711L6.29289 7.70711L7.70711 6.29289L4.20711 2.79289L2.79289 4.20711ZM7.70711 7.70711L11.2071 4.20711L9.79289 2.79289L6.29289 6.29289L7.70711 7.70711Z"
                    fill="#F32626"
                  />
                  <path
                    d="M7 10.5L6.29289 11.2071L7 11.9142L7.70711 11.2071L7 10.5ZM2.79289 7.70711L6.29289 11.2071L7.70711 9.79289L4.20711 6.29289L2.79289 7.70711ZM7.70711 11.2071L11.2071 7.70711L9.79289 6.29289L6.29289 9.79289L7.70711 11.2071Z"
                    fill="#F32626"
                  />
                </svg>
              </span>
            </span>
            <span className="ml-1 font-medium">12.38%</span>
          </p>
          <div className="text-center flex justify-center ml-auto mt-1 mb-4">
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                Y
              </button>
            </div>
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                M
              </button>
            </div>

            <div className="">
              <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                {" "}
                W
              </button>
            </div>
          </div>
        </div>
        <div class="w-full flex-1 shadow-md shadow-slate-400 bg-white sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl mr-6">
          <div className="text-center  mt-4">
            <div className="text-center">
              <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                <svg
                  className="relative top-1.5 left-1.5"
                  width="46"
                  height="46"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="12" cy="12" r="9" stroke="#1F78B4" />
                  <path d="M9.0001 14.9998L15.0001 8.99976" stroke="#1F78B4" />
                  <path d="M15 15L9 9" stroke="#1F78B4" />
                </svg>
              </button>
            </div>
          </div>
          <h1 className="text-4xl text-center font-bold mt-4">758</h1>
          <h1 className="text-lg text-center text-gray-500 mt-2 font-bold">
            Items Returned
          </h1>
          <p className="text-red-600 text-center mb-1">
            <span>
              <span className="inline-block">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                    fill="#F32626"
                  />
                  <path
                    d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                    fill="#F32626"
                  />
                </svg>
              </span>
            </span>
            <span className="ml-1 font-medium">03.38%</span>
          </p>
          <div className="text-center flex justify-center ml-auto mt-1 mb-4">
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                Y
              </button>
            </div>
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                M
              </button>
            </div>

            <div className="">
              <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                {" "}
                W
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Bars Charts top 3 */}

      <div className="mt-8 sm:w-full md:w-full" ref={inventoryRef}>
        <div class=" shadow-slate-400 shadow-md bg-white rounded-2xl flex-1">
          <div className="flex flex-wrap mr-4 mt-2 pt-2">
            <h3 className="text-lg font-bold mx-3"> Inventory Turnover</h3>
            <div className="float-right ml-auto mr-4 mt-1">
              <div className="float-right">
                <button className="rounded-full text-blue-900 w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2 ">
                  {" "}
                  W
                </button>
              </div>
              <div className="float-right">
                <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                  {" "}
                  M
                </button>
              </div>
              <div className="float-right">
                <button className="rounded-full text-blue-900 w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                  {" "}
                  Y
                </button>
              </div>
              <div className="relative text-gray-600 mr-3 border-1 rounded-3xl float-right focus-within:text-gray-400">
                <span className="absolute text-slate-400 inset-y-0 left-0 flex items-center pl-2">
                  <button
                    type="submit"
                    className="p-1 focus:outline-none focus:shadow-outline"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M4 6h16M4 12h8m-8 6h16"
                      />
                    </svg>
                  </button>
                </span>
                <input
                  type="search"
                  className="py-2 text-sm outline-slate-100 outline focus:outline-slate-200 rounded-full pl-10 focus:outline-1 focus:bg-white focus:text-gray-900"
                  placeholder="Filter"
                  autocomplete="off"
                />
              </div>
            </div>
          </div>
          <Chart
            options={Inventory.options}
            series={Inventory.series}
            type="bar"
            height="400"
            width="100%"
          />
        </div>
      </div>
      <div className="mt-8 sm:w-full md:w-full" ref={saleRatioRef}>
        <div class=" shadow-slate-400 shadow-md bg-white rounded-2xl flex-1">
          <div className="flex flex-wrap mr-4 mt-2 pt-2">
            <h3 className="text-lg font-bold mx-3"> Inventory to Sales Ratio</h3>
            <div className="float-right ml-auto mr-4 mt-1">
              <div className="float-right">
                <button className="rounded-full text-blue-900 w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2 ">
                  {" "}
                  W
                </button>
              </div>
              <div className="float-right">
                <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                  {" "}
                  M
                </button>
              </div>
              <div className="float-right">
                <button className="rounded-full text-blue-900 w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                  {" "}
                  Y
                </button>
              </div>
              <div className="relative text-gray-600 mr-3 border-1 rounded-3xl float-right focus-within:text-gray-400">
                <span className="absolute text-slate-400 inset-y-0 left-0 flex items-center pl-2">
                  <button
                    type="submit"
                    className="p-1 focus:outline-none focus:shadow-outline"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M4 6h16M4 12h8m-8 6h16"
                      />
                    </svg>
                  </button>
                </span>
                <input
                  type="search"
                  className="py-2 text-sm outline-slate-100 outline focus:outline-slate-200 rounded-full pl-10 focus:outline-1 focus:bg-white focus:text-gray-900"
                  placeholder="Filter"
                  autocomplete="off"
                />
              </div>
            </div>
          </div>
          <Chart
            options={Inventory.options}
            series={Inventory.series}
            type="bar"
            height="400"
            width="100%"
          />
        </div>
      </div>
      <div className="mt-8 sm:w-full md:w-full" ref={backOrderRef}>
        <div class=" shadow-slate-400 shadow-md bg-white rounded-2xl flex-1">
          <div className="flex flex-wrap mr-4 mt-2 pt-2">
            <h3 className="text-lg font-bold mx-3"> Back Order Rate</h3>
            <div className="float-right ml-auto mr-4 mt-1">
              <div className="float-right">
                <button className="rounded-full text-blue-900 w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2 ">
                  {" "}
                  W
                </button>
              </div>
              <div className="float-right">
                <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                  {" "}
                  M
                </button>
              </div>
              <div className="float-right">
                <button className="rounded-full text-blue-900 w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                  {" "}
                  Y
                </button>
              </div>
              <div className="relative text-gray-600 mr-3 border-1 rounded-3xl float-right focus-within:text-gray-400">
                <span className="absolute text-slate-400 inset-y-0 left-0 flex items-center pl-2">
                  <button
                    type="submit"
                    className="p-1 focus:outline-none focus:shadow-outline"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M4 6h16M4 12h8m-8 6h16"
                      />
                    </svg>
                  </button>
                </span>
                <input
                  type="search"
                  className="py-2 text-sm outline-slate-100 outline focus:outline-slate-200 rounded-full pl-10 focus:outline-1 focus:bg-white focus:text-gray-900"
                  placeholder="Filter"
                  autocomplete="off"
                />
              </div>
            </div>
          </div>
          <Chart
            options={Inventory.options}
            series={Inventory.series}
            type="bar"
            height="400"
            width="100%"
          />
        </div>
      </div>

      {/* line Charts 1 */}

      <div className="mt-8 sm:w-full md:w-full" ref={perfectOrderRef}>
        <div class=" shadow-slate-400 shadow-md bg-white rounded-2xl flex-1">
          <div className="flex flex-wrap mr-4 mt-2 pt-2">
            <h3 className="text-lg font-bold mx-3">
              {" "}
              Perfect Order Rate (Simple)
            </h3>
            <div className="float-right ml-auto mr-4 mt-1">
              <div className="float-right">
                <button className="rounded-full text-blue-900 w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2 ">
                  {" "}
                  W
                </button>
              </div>
              <div className="float-right">
                <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                  {" "}
                  M
                </button>
              </div>
              <div className="float-right">
                <button className="rounded-full text-blue-900 w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                  {" "}
                  Y
                </button>
              </div>
              <div className="relative text-gray-600 mr-3  border-1 rounded-3xl float-right focus-within:text-gray-400">
                <span className="absolute text-slate-400 inset-y-0 left-0 flex items-center pl-2">
                  <button
                    type="submit"
                    className="p-1 focus:outline-none focus:shadow-outline"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M4 6h16M4 12h8m-8 6h16"
                      />
                    </svg>
                  </button>
                </span>
                <input
                  type="search"
                  className="py-2 text-sm outline-slate-100 outline focus:outline-slate-200 rounded-full pl-10 focus:outline-1 focus:bg-white focus:text-gray-900"
                  placeholder="Filter"
                  autocomplete="off"
                />
              </div>
            </div>
          </div>
          <Chart
            options={Perferctorder.options}
            series={Perferctorder.series}
            type="line"
            height="400"
            width="100%"
          />
        </div>
      </div>

      {/* line chart 2 */}

      <div className="mt-8">
        <div class=" shadow-slate-400 shadow-md bg-white rounded-2xl flex-1">
          <div className="flex flex-wrap mr-4 mt-2 pt-2">
            <h3 className="text-lg font-bold mx-3"> Perfect Order Rate</h3>
            <div className="float-right ml-auto mr-4 mt-1">
              <div className="float-right">
                <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2 ">
                  {" "}
                  W
                </button>
              </div>
              <div className="float-right">
                <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                  {" "}
                  M
                </button>
              </div>
              <div className="float-right">
                <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                  {" "}
                  Y
                </button>
              </div>
              <div className="relative text-gray-600 mr-5 ml-4  float-right focus-within:text-gray-400">
                
                
                <input
                  type="date"
                  className="py-2 px-3 text-sm outline-slate-100 outline rounded-lg pl-10 focus:outline-1 focus:outline-slate-200 focus:bg-white focus:text-gray-900"
                  placeholder="Date"
                  autocomplete="off"
                />
                
              </div>
              <div class=" flex border-b border-b-violet-800 mr-6 ">
                <input
                  class="w-full bg-transparent rounded-lg p-2"
                  type="text"
                  placeholder="Search"
                />
                <button class=" w-auto flex justify-end items-center text-blue p-2 hover:text-blue-light">
                  <svg
                    width="19"
                    height="19"
                    viewBox="0 0 19 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.1206 13.7553L13.5772 9.87719C14.4317 8.87406 14.9369 7.64031 14.9369 6.30781C14.9369 2.95469 11.7409 0.226562 7.81186 0.226562C3.88358 0.226562 0.6875 2.95469 0.6875 6.30781C0.6875 9.66156 3.88358 12.3891 7.81186 12.3891C9.30116 12.3891 10.6843 11.9972 11.8295 11.3278L16.397 15.2266L18.1206 13.7553ZM2.77721 6.30781C2.77721 3.93781 5.03607 2.00969 7.81259 2.00969C10.5891 2.00969 12.848 3.93781 12.848 6.30781C12.848 8.67781 10.5891 10.6059 7.81259 10.6059C5.03534 10.6059 2.77721 8.67781 2.77721 6.30781Z"
                      fill="#1F78B4"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <Chart
            options={Orderrate.options}
            series={Orderrate.series}
            type="line"
            height="400"
            width="100%"
          />
        </div>
      </div>

      {/* accuarcy  and item carht */}

      {/* line chart 1 */}

      <div className="mt-8 sm:w-full md:w-full" ref={fulfillmentRef}>
        <div class=" shadow-slate-400 shadow-md bg-white rounded-2xl flex-1">
          <div className="flex flex-wrap mr-4 mt-2 pt-2">
            <h3 className="text-lg font-bold mx-3">
              {" "}
              Fulfillment Accuracy Rate (Simple)
            </h3>
            <div className="float-right ml-auto mr-4 mt-1">
              <div className="float-right">
                <button className="rounded-full text-blue-900 w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2 ">
                  {" "}
                  W
                </button>
              </div>
              <div className="float-right">
                <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                  {" "}
                  M
                </button>
              </div>
              <div className="float-right">
                <button className="rounded-full text-blue-900 w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                  {" "}
                  Y
                </button>
              </div>
              <div className="relative text-gray-600 mr-3  border-1 rounded-3xl float-right focus-within:text-gray-400">
                <span className="absolute text-slate-400 inset-y-0 left-0 flex items-center pl-2">
                  <button
                    type="submit"
                    className="p-1 focus:outline-none focus:shadow-outline"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M4 6h16M4 12h8m-8 6h16"
                      />
                    </svg>
                  </button>
                </span>
                <input
                  type="search"
                  className="py-2 text-sm outline-slate-100 outline focus:outline-slate-200 rounded-full pl-10 focus:outline-1 focus:bg-white focus:text-gray-900"
                  placeholder="Filter"
                  autocomplete="off"
                />
              </div>
            </div>
          </div>
          <Chart
            options={Fulfillment.options}
            series={Fulfillment.series}
            type="line"
            height="400"
            width="100%"
          />
        </div>
      </div>

      {/* line chart 2 */}

      <div className="mt-8" ref={itemSoldRef}>
        <div class=" shadow-slate-400 shadow-md bg-white rounded-2xl flex-1">
          <div className="flex flex-wrap mr-4 mt-2 pt-2">
            <h3 className="text-lg font-bold mx-3"> Items Sold</h3>
            <div className="float-right ml-auto mr-4 mt-1">
              <div className="float-right">
                <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2 ">
                  {" "}
                  W
                </button>
              </div>
              <div className="float-right">
                <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                  {" "}
                  M
                </button>
              </div>
              <div className="float-right">
                <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                  {" "}
                  Y
                </button>
              </div>

              <div className="relative text-gray-600 mr-5 ml-4 float-right focus-within:text-gray-400">
                <input
                  type="date"
                  className="py-2 px-3 text-sm outline-slate-100 outline rounded-lg pl-10 focus:outline-1 focus:outline-slate-200 focus:bg-white focus:text-gray-900"
                  placeholder="Date"
                  autocomplete="off"
                />
              </div>
              <div class=" flex border-b border-b-violet-800 mr-6 ">
                <input
                  class="w-full bg-transparent rounded-lg p-2"
                  type="text"
                  placeholder="Search"
                />
                <button class=" w-auto flex justify-end items-center text-blue p-2 hover:text-blue-light">
                  <svg
                    width="19"
                    height="19"
                    viewBox="0 0 19 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.1206 13.7553L13.5772 9.87719C14.4317 8.87406 14.9369 7.64031 14.9369 6.30781C14.9369 2.95469 11.7409 0.226562 7.81186 0.226562C3.88358 0.226562 0.6875 2.95469 0.6875 6.30781C0.6875 9.66156 3.88358 12.3891 7.81186 12.3891C9.30116 12.3891 10.6843 11.9972 11.8295 11.3278L16.397 15.2266L18.1206 13.7553ZM2.77721 6.30781C2.77721 3.93781 5.03607 2.00969 7.81259 2.00969C10.5891 2.00969 12.848 3.93781 12.848 6.30781C12.848 8.67781 10.5891 10.6059 7.81259 10.6059C5.03534 10.6059 2.77721 8.67781 2.77721 6.30781Z"
                      fill="#1F78B4"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <Chart
            options={Solditems.options}
            series={Solditems.series}
            type="line"
            height="400"
            width="100%"
          />
        </div>
      </div>

      {/* shipping chart and retrun items chart */}

      {/* line chart 1 */}

      <div className="mt-8 sm:w-full md:w-full" ref={shippingRef}>
        <div class=" shadow-slate-400 shadow-md bg-white rounded-2xl flex-1">
          <div className="flex flex-wrap mr-4 mt-2 pt-2">
            <h3 className="text-lg font-bold mx-3"> On-Time Shipping Rate</h3>
            <div className="float-right ml-auto mr-4 mt-1">
              <div className="float-right">
                <button className="rounded-full text-blue-900 w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2 ">
                  {" "}
                  W
                </button>
              </div>
              <div className="float-right">
                <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                  {" "}
                  M
                </button>
              </div>
              <div className="float-right">
                <button className="rounded-full text-blue-900 w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                  {" "}
                  Y
                </button>
              </div>
              <div className="relative text-gray-600 mr-3  border-1 rounded-3xl float-right focus-within:text-gray-400">
                <span className="absolute text-slate-400 inset-y-0 left-0 flex items-center pl-2">
                  <button
                    type="submit"
                    className="p-1 focus:outline-none focus:shadow-outline"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M4 6h16M4 12h8m-8 6h16"
                      />
                    </svg>
                  </button>
                </span>
                <input
                  type="search"
                  className="py-2 text-sm outline-slate-100 outline focus:outline-slate-200 rounded-full pl-10 focus:outline-1 focus:bg-white focus:text-gray-900"
                  placeholder="Filter"
                  autocomplete="off"
                />
              </div>
            </div>
          </div>
          <Chart
            options={Shipping.options}
            series={Shipping.series}
            type="line"
            height="400"
            width="100%"
          />
        </div>
      </div>

      {/* line chart 2 */}

      <div className="mt-8 sm:w-full md:w-full" ref={returnRef}>
        <div class=" shadow-slate-400 shadow-md bg-white rounded-2xl flex-1">
          <div className="flex flex-wrap mr-4 mt-2 pt-2">
            <h3 className="text-lg font-bold mx-3"> Rate of Returns</h3>
            <div className="float-right ml-auto mr-4 mt-1">
              <div className="float-right">
                <button className="rounded-full text-blue-900 w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2 ">
                  {" "}
                  W
                </button>
              </div>
              <div className="float-right">
                <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                  {" "}
                  M
                </button>
              </div>
              <div className="float-right">
                <button className="rounded-full text-blue-900 w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                  {" "}
                  Y
                </button>
              </div>
              <div className="relative text-gray-600 mr-3  border-1 rounded-3xl float-right focus-within:text-gray-400">
                <span className="absolute text-slate-400 inset-y-0 left-0 flex items-center pl-2">
                  <button
                    type="submit"
                    className="p-1 focus:outline-none focus:shadow-outline"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M4 6h16M4 12h8m-8 6h16"
                      />
                    </svg>
                  </button>
                </span>
                <input
                  type="search"
                  className="py-2 text-sm outline-slate-100 outline focus:outline-slate-200 rounded-full pl-10 focus:outline-1 focus:bg-white focus:text-gray-900"
                  placeholder="Filter"
                  autocomplete="off"
                />
              </div>
            </div>
          </div>
          <Chart
            options={Return.options}
            series={Return.series}
            type="line"
            height="400"
            width="100%"
          />
        </div>
      </div>

      {/* 2 bar charts */}

      <div className="mt-8 sm:w-full md:w-full" ref={totalOrderRef}>
        <div class=" shadow-slate-400 shadow-md bg-white rounded-2xl flex-1">
          <div className="flex flex-wrap mr-4 mt-2 pt-2">
            <h3 className="text-lg font-bold mx-3"> Total Order Cycle Time</h3>
            <div className="float-right ml-auto mr-4 mt-1">
              <div className="float-right">
                <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                  {" "}
                  M
                </button>
              </div>
              <div className="float-right">
                <button className="rounded-full text-blue-900 w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                  {" "}
                  Y
                </button>
              </div>
              <div className="relative text-gray-600 mr-3  border-1 rounded-3xl float-right focus-within:text-gray-400">
                <span className="absolute text-slate-400 inset-y-0 left-0 flex items-center pl-2">
                  <button
                    type="submit"
                    className="p-1 focus:outline-none focus:shadow-outline"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M4 6h16M4 12h8m-8 6h16"
                      />
                    </svg>
                  </button>
                </span>
                <input
                  type="search"
                  className="py-2 text-sm outline-slate-100 outline focus:outline-slate-200 rounded-full pl-10 focus:outline-1 focus:bg-white focus:text-gray-900"
                  placeholder="Filter"
                  autocomplete="off"
                />
              </div>
            </div>
          </div>
          <Chart
            options={Inventory.options}
            series={Inventory.series}
            type="bar"
            height="400"
            width="100%"
          />
        </div>
      </div>
      <div className="mt-8 sm:w-full md:w-full">
        <div class=" shadow-slate-400 shadow-md bg-white rounded-2xl flex-1">
          <div className="flex flex-wrap mr-4 mt-2 pt-2">
            <h3 className="text-lg font-bold mx-3"> Order Lead Time</h3>
            <div className="float-right ml-auto mr-4 mt-1">
              <div className="float-right">
                <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                  {" "}
                  M
                </button>
              </div>
              <div className="float-right">
                <button className="rounded-full text-blue-900 w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                  {" "}
                  Y
                </button>
              </div>
              <div className="relative text-gray-600 mr-3  border-1 rounded-3xl float-right focus-within:text-gray-400">
                <span className="absolute text-slate-400 inset-y-0 left-0 flex items-center pl-2">
                  <button
                    type="submit"
                    className="p-1 focus:outline-none focus:shadow-outline"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M4 6h16M4 12h8m-8 6h16"
                      />
                    </svg>
                  </button>
                </span>
                <input
                  type="search"
                  className="py-2 text-sm outline-slate-100 outline focus:outline-slate-200 rounded-full pl-10 focus:outline-1 focus:bg-white focus:text-gray-900"
                  placeholder="Filter"
                  autocomplete="off"
                />
              </div>
            </div>
          </div>
          <Chart
            options={Inventory.options}
            series={Inventory.series}
            type="bar"
            height="400"
            width="100%"
          />
        </div>
      </div>
      </main>
  );
}
